// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-7306c7f1]{fill:#f6caae}.cls-2[data-v-7306c7f1]{fill:#f5d3bd}.cls-3[data-v-7306c7f1]{fill:#eab599}.cls-4[data-v-7306c7f1]{fill:var(--v-primary-base)}", ""]);
// Exports
module.exports = exports;
